<template>
	<el-dialog
		title="预约"
		:visible.sync="appointmentTimeDialogVisible"
		:before-close="handleCancel"
        width="400px"
        class="appointmentTimeDialog"
	>
		<el-form
			:model="ruleForm"
			:rules="rules"
			ref="ruleForm"
			label-width="100px"
		>
			<el-form-item label="预约配送日期" prop="lspAppointmentTime">
				<el-date-picker
					type="date"
					placeholder="选择日期"
					v-model="ruleForm.lspAppointmentTime"
					style="width: 100%;"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
				></el-date-picker>
			</el-form-item>
		</el-form>
		<div class="dis-footer">
			<el-button @click="handleCancel">取 消</el-button>
			<el-button type="primary" @click="handleSure" :loading="handleAllocateLoading">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { updateLspAppointmentTimeApi } from '../../../../api/sieveSingleCenter';
export default {
	props: {
		appointmentTimeDialogVisible: {
			type: Boolean,
			default: false,
		},
		rowData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	data() {
		return {
			handleAllocateLoading: false,
			ruleForm: {
				lspAppointmentTime: '',
			},
			rules: {
				lspAppointmentTime: [
					{required: true, message: "请选择时间", trigger: "change",},
				],
            },
            pickerOptions: {
                disabledDate: time => {
                    // return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;// 今天之前不允许选择
                }
            },
		};
	},
    methods: {
        handleCancel () {
            this.$emit('update:appointmentTimeDialogVisible', false)
        },
        handleSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) return;
                let params = {
                    taskNo: this.rowData.taskNo,
                    lspAppointmentTime: this.ruleForm.lspAppointmentTime
                }
                this.handleAllocateLoading = true;
                updateLspAppointmentTimeApi(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('预约成功')
                    this.$emit('appointmentTimeDialogOk')
                    }
                }).finally(() => {
                    this.handleAllocateLoading = false;
                })
            })
        }
    },
};
</script>
<style lang="less">
.appointmentTimeDialog{
    .dis-footer {
        text-align: right;
        margin-top: 15px;
    }
}
</style>
